import React, { Component } from "react";
import { Container, Grid, Card, Button, Form, Avatar, Media, Icon,Table } from "tabler-react";
import SiteWrapper from "../SiteWrapper.react";
import { Crud_Catalogos, Crud_error } from '../herramientas/Crud_Catalogos';
import { NotificationContainer, NotificationManager} from 'react-notifications';
import {password} from '../herramientas/Forms';
import { GetUser, GetRoles } from "../herramientas/JWT";


//Del profile original:
var perfil= JSON.parse(sessionStorage.getItem("perfil"));


class  ProfilePage extends Component {
  constructor(props) {
    super(props);
              this.state  = {
                              currentTap  : 0,
                                      id  : 0,
                                 estatus  : 0,
                                  accion  : this.props.accion, //'nuevo'// modificar, nuevo
                         crudbutonEnable  : true, // Se desabilita cuando se hace click
                              hiddenModal : false,
                                 mensaje  : [],
                                 pass:false,
                              newPassword : "",
                              newPasswordC : ""
              };
      
      this.passwordObj= {
	
        "oldPassword" : "",
        "newPassword" : "",
       "newPasswordC" : ""
      } 

  }


  componentDidMount = () => {}
  
  changeOldPassword = (event) => {
    this.passwordObj.oldPassword=event.target.value;  
  }
  changeNewPassword = (event) => {  
    this.passwordObj.newPassword=event.target.value;  
    this.setState({newPassword:event.target.value})
  }
  changeNewPasswordC = (event) => {
  this.setState({newPasswordC:event.target.value})

  }
  crud_putPassword() {
    Crud_Catalogos("usuarios/password_from_user", "put", this.passwordObj, "").then((returnVal) => {
      if(returnVal.status===200){
        NotificationManager.success(returnVal.message, "Modificación");
      }else{
        NotificationManager.error(returnVal.message, "Modificación");
      }
      //window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }

  render(){
    return (
      
      <SiteWrapper>
        <div className="my-3 my-md-5">
          <Container>
            <Grid.Row>

              <Grid.Col lg={4}>
                <Card>
                  <Card.Body>
                    <Media>
                      <Avatar
                        size="xxl"
                        className="mr-5"
                        imageURL="./user/user.png"
                      />
                      <Media.BodySocial
                        name={ GetUser()}
                        workTitle={ GetRoles() }

                      />
                    </Media>
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Body>
                    <span Nameclass="badge"><Icon link={true} name="mail" />Correo : correo@skyangel.com.mx</span>
                  </Card.Body>
                </Card>
                </Grid.Col>
                <Grid.Col lg={8}>
                  { this.state.pass?
                    <Card>
                      <Card.Body>
                        <Grid.Row>
                          <Grid.Col md={4 } lg={4}>              
                        
                            <Form.Group label="Password Anterior">             
                              <Form.Input name="oldPassword" type="password" onChange={this.changeOldPassword} />
                              </Form.Group>
                          </Grid.Col>
                    
                          <Grid.Col md={ 4 } lg={ 4 }>
                            <Form.Group label="Nuevo Password">
                              <Form.Input name="newPassword" type="password"  value={this.state.newPassword} onChange={this.changeNewPassword} />
                              <div >{password(this.state.newPassword)}</div>
                            </Form.Group>
                          </Grid.Col>          
                          <Grid.Col md={4} lg={4}>
                              <Form.Group label="Confirmar Password">
                                <Form.Input name="newPasswordC" type="password"  onChange={this.changeNewPasswordC} />
                                <div>{this.state.newPasswordC.length?this.state.newPasswordC===this.state.newPassword?"":"Las contraseñas no son iguales":""}</div>
                              </Form.Group>
                          </Grid.Col>
                          <Table.Col>
                                <Button target="_blank" size="sm" RootComponent="a" color="primary"
                                disabled= { this.habilitarBoton()}
                                onClick={() => this.crud_putPassword() }
                                >
                                <span class="badge"><Icon link={true} name="refresh-ccw" /></span>
                                </Button>
                                <Button target="_blank" size="sm" RootComponent="a" color="danger" onClick={()=> this.setState({ pass: false}) } className="ml-2">
                                <span class="badge"><Icon link={true} name="x" />Cancelar</span>
                                </Button>           
                          </Table.Col>
                        
                        </Grid.Row>
                      </Card.Body>
                    </Card>:<a onClick={()=> this.setState({ pass: true})} className="text-primary">Cambiar contraseña</a>
                  }
                  
              </Grid.Col>
            </Grid.Row>
          </Container>
        </div>
      </SiteWrapper>
      
    )
  }

habilitarBoton=()=> {
    //return this.passwordObj.newPasswordC !== this.passwordObj.newPassword && (!this.passwordObj.newPassword.length || !this.passwordObj.newPasswordC.length );
    if (!password(this.state.newPassword).length && this.state.newPassword===this.state.newPasswordC){
       return false;
    }
    return true;
}




}

export default ProfilePage

